import React from "react";
import { Nav } from "rsuite";
import { Receipt } from "../../../components/receipt/Receipt";
import { useAtendimentoContext } from "../context/AtendimentoContext";
import { AtendimentosGrid } from "../grids/AtendimentosGrid";
import { ProcedimentosGrid } from "../grids/ProcedimentosGrid";

const AtendimentoNav = () => {
  const {
    form,
    activeNav,
    setActiveNav,
    visible,
    setVisible,
    data,
    setDisabled,
  } = useAtendimentoContext();

  const CustomNav = ({ active, onSelect, ...props }) => {
    const hasConsulta = form?.consultaMedica.some(item => item.check)
    return (
      <Nav
        {...props}
        activeKey={active}
        onSelect={onSelect}
        style={{ marginBottom: 10 }}
      >
        <Nav.Item eventKey="atendimentos">Atendimentos</Nav.Item>
        <Nav.Item
          eventKey="procedimentos"
          disabled={!hasConsulta}
        >
          Procedimentos
        </Nav.Item>
      </Nav>
    );
  };

  const Navs = () => {
    switch (activeNav) {
      case "atendimentos":
        return <AtendimentosGrid />;
      case "procedimentos":
        return <ProcedimentosGrid />;
      default:
        break;
    }
  };

  return form?.idAcAdminCartao ? (
    <div className="pageContainer">
      {data && (
        <Receipt
          toggleModal={() => {
            setVisible(!visible);
            setDisabled(true);
          }}
          visible={visible}
          data={data}
        ></Receipt>
      )}

      <CustomNav
        appearance="tabs"
        active={activeNav}
        onSelect={(activeKey) => setActiveNav(activeKey)}
        style={{ marginTop: 15 }}
      />
      {Navs()}
    </div>
  ) : null;
};

export { AtendimentoNav };

